class ProductDeliveryUpsell extends HTMLElement {
    static name = 'product-delivery-upsell';
    
    constructor() {
        super();
    }

    connectedCallback() {
        this.initializeComponent();

        // Always show Add to cart on connect — button visibility driven by upsell-product.js package selection,
        // not by delivery packages (which are hidden until "Yes" tab is clicked).
        setTimeout(() => {
            if (this.button) {
                this.button.setAttribute('style', 'display: block');
            }
            if (this.addButtons.length > 0) {
                this.addButtons.forEach((el) => {
                    el.setAttribute('style', 'display: none');
                });
            }
        }, 200);

        // Inicializar modal del chiller desde este componente
        setTimeout(() => {
            this.initChillerModal();
        }, 100);
    }

    initializeComponent() {
        setTimeout(() => {
            this.setupTabNavigation();
            this.setupDeliveryPackageSelector();
        }, 100);
    }

    get tabButtons() {
        return this.querySelectorAll('.delivery-tabs .tab');
    }

    get tabBodies() {
        return this.querySelectorAll('.delivery-tabs-body .tab');
    }

    get deliveryPackageOptions() {
        return this.querySelectorAll('.delivery-package-option');
    }

    get button() {
        return document.querySelector('button[id="btn-addcart-smg"]');
    }

    get addButtons() {
        return document.querySelectorAll('product-add-button');
    }

    setupTabNavigation() {
        this.tabButtons.forEach(tab => {
            tab.addEventListener('click', (evt) => {
                this.handleTabClick(evt);
            });
        });
    }

    handleTabClick(evt) {
        const clickedTab = evt.currentTarget;
        const tabType = clickedTab.getAttribute('type');
        
        // Remover clase active de todos los tabs
        this.tabButtons.forEach(tab => tab.classList.remove('active'));
        this.tabBodies.forEach(body => body.classList.remove('active'));
        
        // Agregar clase active al tab clickeado
        clickedTab.classList.add('active');
        
        // Mostrar/ocultar el cuerpo del tab correspondiente
        const targetBody = this.querySelector(`.delivery-tabs-body .tab[type="${tabType}"]`);
        if (targetBody) {
            targetBody.classList.add('active');
        }
        
        // Si es "no", limpiar selecciones de delivery
        if (tabType === 'no') {
            this.clearDeliverySelections();
        }
    }

    setupDeliveryPackageSelector() {
        this.deliveryPackageOptions.forEach(option => {
            option.addEventListener('click', (evt) => {
                this.handleDeliveryPackageClick(evt.currentTarget);
            });
        });
    }

    handleDeliveryPackageClick(packageOption) {
        const isCurrentlySelected = packageOption.classList.contains('selected');
        
        // Limpiar todas las selecciones previas
        this.deliveryPackageOptions.forEach(option => {
            option.classList.remove('selected');
        });
        
        // Si no estaba seleccionado, seleccionarlo
        if (!isCurrentlySelected) {
            packageOption.classList.add('selected');
        }
    }

    clearDeliverySelections() {
        this.deliveryPackageOptions.forEach(option => {
            option.classList.remove('selected');
        });
    }

    getSelectedDeliveryPackage() {
        const selectedOption = this.querySelector('.delivery-package-option.selected');
        if (selectedOption) {
            return {
                id: selectedOption.dataset.productId,
                variantId: selectedOption.dataset.variantId,
                price: selectedOption.dataset.price,
                handle: selectedOption.dataset.handle,
                title: selectedOption.dataset.title
            };
        }
        return null;
    }

    isYesTabActive() {
        const yesTab = this.querySelector('.delivery-tabs .tab[type="yes"]');
        return yesTab && yesTab.classList.contains('active');
    }

    // ===== Modal Chiller integration =====
    initChillerModal() {
        console.log('[DeliveryUpsell][ChillerModal] initChillerModal');
        // Abrir desde botones internos del componente
        this.querySelectorAll('.open-modal, .open_modal-chiller, .open-modal-chiller')
            .forEach((btn) => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    console.log('[DeliveryUpsell][ChillerModal] opener clicked:', btn);
                    this.openChillerModal();
                });
            });

        // Delegación sobre el documento para robustez (por si se re-renderiza contenido)
        if (!this._docOpenBound) {
            this._docOpenBound = true;
            document.addEventListener('click', (e) => {
                const opener = e.target.closest?.('.open-modal, .open_modal-chiller, .open-modal-chiller');
                if (opener && this.contains(opener)) {
                    e.preventDefault();
                    console.log('[DeliveryUpsell][ChillerModal] document opener clicked:', opener);
                    this.openChillerModal();
                }
            }, true);
        }

        // Delegación para cierre y acordeón dentro del modal
        const modal = this.getChillerModalSection();
        modal?.addEventListener('click', (e) => {
            const target = e.target;
            const closeTrigger = target.closest?.('.close-modal, .btn-close-modal');
            if (closeTrigger) {
                e.preventDefault();
                console.log('[DeliveryUpsell][ChillerModal] close clicked');
                this.closeChillerModal();
                return;
            }
            if (e.target === modal) {
                console.log('[DeliveryUpsell][ChillerModal] overlay clicked');
                this.closeChillerModal();
            }
        }, true);

        document.addEventListener('keydown', (e) => {
            const m = this.getChillerModalSection();
            if (e.key === 'Escape' && m && m.classList.contains('active')) {
                console.log('[DeliveryUpsell][ChillerModal] ESC pressed');
                this.closeChillerModal();
            }
        });

        // Intentar preparar el acordeón si el modal ya existe en el DOM
        this.initChillerAccordion();
    }

    getChillerModalSection() {
        return document.querySelector('.product-modal-chiller_section');
    }

    async openChillerModal() {
        let modalSection = this.getChillerModalSection();
        if (!modalSection) {
            console.warn('[DeliveryUpsell][ChillerModal] modal not found, fetching section…');
            modalSection = await this.ensureChillerModalPresent();
            if (!modalSection) {
                console.warn('[DeliveryUpsell][ChillerModal] modal still not found after fetch');
                return;
            }
        }
        console.log('[DeliveryUpsell][ChillerModal] Opening modal');
        modalSection.classList.add('active');
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';

        // Bind direct close listeners (por si faltan)
        const closeBtn = modalSection.querySelector('.close-modal');
        const closeCta = modalSection.querySelector('.btn-close-modal');
        closeBtn?.addEventListener('click', (e) => { e.preventDefault(); this.closeChillerModal(); }, true);
        closeCta?.addEventListener('click', (e) => { e.preventDefault(); this.closeChillerModal(); }, true);

        // Preparar acordeón al abrir (asegura funcionamiento aunque se inyecte dinámicamente)
        this.initChillerAccordion();
    }

    closeChillerModal() {
        const modalSection = this.getChillerModalSection();
        if (!modalSection) return;
        console.log('[DeliveryUpsell][ChillerModal] Closing modal');
        modalSection.classList.remove('active');
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
    }

    async ensureChillerModalPresent() {
        try {
            const url = `${window.location.pathname}?section_id=product-modal-chiller`;
            const res = await fetch(url, { credentials: 'same-origin' });
            if (!res.ok) return null;
            const html = await res.text();
            const temp = document.createElement('div');
            temp.innerHTML = html;
            // Inyectar estilos si vienen
            temp.querySelectorAll('style, link[rel="stylesheet"]').forEach((node) => {
                try {
                    if (node.tagName === 'STYLE') {
                        const content = node.textContent?.trim();
                        if (content && !document.head.textContent?.includes(content)) {
                            const clone = document.createElement('style');
                            clone.textContent = content;
                            document.head.appendChild(clone);
                        }
                    } else if (node.tagName === 'LINK') {
                        const href = node.getAttribute('href');
                        if (href && !document.head.querySelector(`link[rel="stylesheet"][href="${href}"]`)) {
                            const link = document.createElement('link');
                            link.rel = 'stylesheet';
                            link.href = href;
                            document.head.appendChild(link);
                        }
                    }
                } catch(_) {}
            });
            const modal = temp.querySelector('.product-modal-chiller_section');
            if (modal) {
                document.body.appendChild(modal);
                return modal;
            }
            return null;
        } catch (e) {
            console.warn('[DeliveryUpsell][ChillerModal] ensureChillerModalPresent error', e);
            return null;
        }
    }

    // ===== Acordeón del modal (como en assets/upsell-product.js) =====
    initChillerAccordion() {
        const modal = this.getChillerModalSection();
        if (!modal) return;
        const list = modal.querySelector('.product-modal-chiller_container .modal-accordion-list');
        if (!list) return;

        // Evitar múltiples bindings sobre el mismo contenedor
        if (this._accordionBoundEl === list) return;
        this._accordionBoundEl = list;

        list.addEventListener('click', (e) => {
            const title = e.target.closest?.('.title-item');
            if (!title) return;
            const item = title.closest('.modal-accordion-item');
            if (!item) return;
            const desc = item.querySelector('.list-description-item');
            if (!desc) return;

            const items = list.querySelectorAll('.modal-accordion-item');
            // Cerrar otros
            items.forEach((other) => {
                if (other !== item) {
                    other.classList.remove('active');
                    const otherDesc = other.querySelector('.list-description-item');
                    if (otherDesc) otherDesc.style.maxHeight = '0';
                }
            });

            // Alternar el actual
            if (item.classList.contains('active')) {
                item.classList.remove('active');
                desc.style.maxHeight = '0';
            } else {
                item.classList.add('active');
                // Igual que en upsell-product.js: añadir 130px extra
                const extra = 130;
                desc.style.maxHeight = (desc.scrollHeight + extra) + 'px';
            }
        });
    }
}

// Registrar el componente
if (!customElements.get('product-delivery-upsell')) {
    customElements.define('product-delivery-upsell', ProductDeliveryUpsell);
}